import React from "react"
import { Link } from "gatsby"

import Layout from "../components/Layout"
import SEO from "../components/SEO"

class IndexPage extends React.Component {
  render() {
    const siteTitle = "Home"

    return (
      <Layout location={this.props.location} title={siteTitle}>
        <SEO
          title={siteTitle}
          keywords={[`blog`, `gatsby`, `javascript`, `react`]}
        />
        <h1>
          Hey people{" "}
          <span role="img" aria-label="wave emoji">
            👋
          </span>
        </h1>
        <p>
          Welcome to my personal website and blog, created for learning
          purposes.
        </p>
        <p>
        My name is Israel de Jesus Lage, 23 years old. Passionate about technology and addicted to learning new things.
        </p>
        <p>Now go build something great!</p>
        <Link to="/blog/">Go to Blog</Link>
      </Layout>
    )
  }
}

export default IndexPage
